import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { ProjectValuationTabs } from '../../enum';
import { NavigationActionBase } from '../../navigation-action-base';
import { NavigationService } from '../../navigation.service';
import { EventBusService } from '../../../services/event-bus.service';
import { AppStorageService } from '../../../services/app-storage.service';
/**
 * Handles the dashboard navigation component
 */
@Component({
  selector: 'dashboard-navigation',
  templateUrl: './dashboard-navigation.component.html'
})
export class DashboardNavigationComponent extends NavigationActionBase implements OnInit {
  /**
   * Search tab visible flag
   */
  @Input() searchTabVisible: boolean;
  /**
   * Change detector reference
   */
  _ref: ChangeDetectorRef;
  /**
   * Navigation service
   */
  _navigationService: NavigationService;
  /**
   * Selected tab
   */
  selectedTab: ProjectValuationTabs = ProjectValuationTabs.Projects;
  /**
   * Report publish enabled flag
   */
  reportPublishEnabled = environment.reportPublishEnabled;
  /**
   * Search mode
   */
  searchMode = 'report';
  /**
   * Active infobar
   */
  activeInfobar = '';
  /**
   * Constructor
   * @param ref
   * @param navigationService
   */
  constructor(appStorage: AppStorageService, eventBus: EventBusService,ref: ChangeDetectorRef, navigationService: NavigationService) {
    super(appStorage, eventBus, ref, navigationService);
    this._ref = ref;
    this._navigationService = navigationService;
  }
  /**
   * NgOnInit
   */
  ngOnInit(): void {
    super.ngOnInit();
    this.subscribeToActiveTab();
  }
  /**
   * Subscribe to active tab
   */
  subscribeToActiveTab() {
    this.subscriptions.add(this._navigationService.activeProjectValuationTab$.subscribe(tab => {
      this.selectedTab = tab;
      if (this.searchTabVisible) {
        this.searchTabVisible = !this.searchTabVisible;
      }
      this._ref.markForCheck();
    }))
  }
  /**
   * Set search bar visibility
   */
  setSearchBarVisibility() {
    this.searchTabVisible = !this.searchTabVisible;
    this.eventBus.broadcastEvent('searchBarVisibility', this.searchTabVisible, this.searchMode);
  }
  /**
   * Set info bar attachment visibility
   */
  setInfoBarFileAttachmentVisibility() {
    this.activeInfobar = 'fileAttachmentsReport';
    this.toggleActiveInfobar({ infobarType: this.activeInfobar });
  }
  /**
   * Toggle active info bar
   * @param params
   */
  toggleActiveInfobar(params: any) {
    this.eventBus.broadcastEvent(`buttonTogglePVInfoModeClicked`, params);
  }

  /**
* Export reports to Excel
* */
  exportToExcel() {
    this.eventBus.broadcastEvent('exportToExcelReportsGrid');
  }
}
